import { makeApiCall } from "../apiRequest";

export default {
  state: {
    tempTaskList: [],
    templateList: [],
    assignTemplateTask: [],
    allTasksRooms: [],
    allTasksTickets: [],
    allAssignTemplates: [],
    todayTemplates: [],
    pastTemplates: [],
  },
  getters: {
    getTempTask: (state) => state.tempTaskList,
    getAssignTemplate: (state) => state.assignTemplateTask,
    getTemplate: (state) => state.templateList,
    getAllTasksRooms: (state) => state.allTasksRooms,
    getAllTasksTickets: (state) => state.allTasksTickets,
    getAllAssignTemplates: (state) => state.allAssignTemplates,
    getTodayTemplates: (state) => state.todayTemplates,
    getPastTemplates: (state) => state.pastTemplates,
  },
  actions: {
    async getDatesOfAssignTemplates() {
      const response = await makeApiCall(
        "assignTemplateService/getDatesOfAssignTemplates",
        "GET"
      );
      return response;
    },
    async getPastTemplates({ commit }, payload) {
      const url = `assignTemplateService/pastTemplate`;
      const response = await makeApiCall(url, "POST", payload);
      if (!response.error) {
        commit("setPastTemplates", response.data.data);
      }
      return response;
    },
    async getTodayTemplates({ commit }, payload) {
      const url = `assignTemplateService/todayTemplate`;
      const response = await makeApiCall(url, "POST", payload);
      if (!response.error) {
        commit("setTodayTemplates", response.data.data);
      }
      return response;
    },
    async getAllAssignTemplates({ commit }, id) {
      const url = `assignTemplateService/get?AssignTemplateId=${id}`;
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setAllAssignTemplates", response.data);
      }
      return response;
    },
    async addTempTask({ commit }, payload) {
      try {
        const response = await makeApiCall(`task/save`, `POST`, payload);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async addTemplete({ commit }, payload) {
      try {
        const response = await makeApiCall(`template/save`, `POST`, payload);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async getTempTask({ commit }, payload) {
      const response = await makeApiCall("task/getAll", "POST", payload);
      if (!response.error) {
        commit("setTempTask", response.data.data);
      }
      return response;
    },
    async getTemplate({ commit }, payload) {
      const response = await makeApiCall("template/getAll", "POST", payload);
      if (!response.error) {
        commit("setTemplate", response.data.data);
      }
      return response;
    },
    async getAssignTemplate({ commit }, payload) {
      const response = await makeApiCall(
        "assignTemplateService/getAll",
        "POST",
        payload
      );
      if (!response.error) {
        commit("setAssignTemplate", response.data.data);
      }
      return response;
    },
    async getAllTasksTickets({ commit }, payload) {
      const response = await makeApiCall(
        "assignTemplateService/GetTemplateTasksWithRoomsAndTickets",
        "POST",
        payload
      );
      if (!response.error) {
        commit("setAllTasksTicket", response.data.data);
      }
      return response;
    },
    async getAllTasksRooms({ commit }, payload) {
      const response = await makeApiCall(
        `assignTemplateService/getAllTasksRooms?assignTemplateId=${payload.id}&isCompleted=${payload.isCompleted}&managerId=${payload.managerId}`,
        "GET",
        payload
      );
      if (!response.error) {
        commit("setAllTasksRooms", response.data.data);
      }
      return response;
    },
    async addAssignTemplate({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `assignTemplateService/assignedTemplateSchedule`,
          `POST`,
          payload
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async deleteAssignTemplate({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `assignTemplateService/delete`,
          `DELETE`,
          payload
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async deleteTempTask({ commit }, payload) {
      try {
        const response = await makeApiCall(`task/delete`, `DELETE`, payload);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async deleteTemplate({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `template/delete`,
          `DELETE`,
          payload
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  },
  mutations: {
    setTempTask(state, payload) {
      state.tempTaskList = payload;
    },
    setTemplate(state, payload) {
      state.templateList = payload;
    },
    setAssignTemplate(state, payload) {
      state.assignTemplateTask = payload;
    },
    setAllTasksRooms(state, payload) {
      state.allTasksRooms = payload;
    },
    setAllTasksTicket(state, payload) {
      state.allTasksTickets = payload;
    },
    setAllAssignTemplates(state, payload) {
      state.allAssignTemplates = payload;
    },
    setTodayTemplates(state, payload) {
      state.todayTemplates = payload;
    },
    setPastTemplates(state, payload) {
      state.pastTemplates = payload;
    },
  },
};
